export default __webpack_public_path__ + "static/media/HomepageGraphic.8db7639d.png";